import * as React from 'react'
import { FC } from 'react'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import Link from '@mui/material/Link'

interface Props {
  onNewOpportunityClick: () => void
  soldServiceStatus: SOLD_SERVICE_STATUS
  onReOpenClick: () => void
  textColor: string
}

const styles = {
  link: {
    color: (props) => props.textColor,
    cursor: 'pointer',
    fontFamily: 'Source Sans Pro Semibold',
    '&:hover': {
      color: (props) => props.textColor,
    },
  },
}

export const SoldServicesBannerDetails: FC<Props> = (props) => {
  const { onNewOpportunityClick, onReOpenClick, soldServiceStatus } = props
  switch (soldServiceStatus) {
    case 'Completed':
      return (
        <span>
          - Submission to the Closed Won Queue has successfully been completed.
          This opportunity can no longer be re-opened. Please Create a{' '}
          <Link
            sx={styles.link}
            onClick={onNewOpportunityClick}
            data-test-id="new-opportunity-from-complete-link"
          >
            new opportunity
          </Link>{' '}
          to add additional services if needed.
        </span>
      )

    case 'Processing':
      return (
        <span>
          - Submission is in the Closed Won Queue and being processed and cannot
          be re-opened in this status. Create a{' '}
          <Link
            sx={styles.link}
            onClick={onNewOpportunityClick}
            data-test-id="new-opportunity-from-processing-link"
          >
            new opportunity
          </Link>{' '}
          to add additional services for this customer.
        </span>
      )

    case 'Revise':
      return (
        <span>
          - Submission has been rejected and must be re-submitted.{' '}
          <Link
            sx={styles.link}
            onClick={onReOpenClick}
            data-test-id="reopen-opportunity-from-revise-link"
          >
            Re-open
          </Link>{' '}
          this opportunity to make needed updates and re-submit it.
        </span>
      )

    case 'Submitted':
      return <span>to the Closed Won Queue</span>
    default:
      return null
  }
}
SoldServicesBannerDetails.displayName = 'SoldServicesBannerDetails'
